module.exports = __webpack_public_path__ + "static/media/luma-banner-0.47816527.png";